













































import { Vue, Component, PropSync, Prop, Ref, Watch } from "vue-property-decorator"
import { FormModel } from "ant-design-vue"
import { mapGetters } from "vuex"

@Component({
    computed: {
        ...mapGetters("common", ["preparation_status"])
    }
})
export default class RollbackModal extends Vue {
    @PropSync("visible", { type: Boolean }) visible_: boolean
    // 当前记录的编制状态，回退目标只能是更早的节点
    @Prop({ type: Number, default: undefined }) currentPreparationStatus: number

    readonly preparation_status: any

    // 只能回退到比当前编制状态更早的节点：
    // 合规编制中(2)->[法务编制中(1)]；编制完成(3)->[法务编制中(1),合规编制中(2)]
    get rollbackOptions() {
        return (this.preparation_status || []).filter(
            (item: any) =>
                this.currentPreparationStatus && item.value < this.currentPreparationStatus
        )
    }

    rollbackForm: any = {
        target_preparation_status: undefined,
        reason: ""
    }

    @Ref("rollbackForm")
    rollbackRef: FormModel

    @Watch("visible_")
    onVisibleChange(val: boolean) {
        if (val) {
            this.rollbackForm.target_preparation_status = undefined
            this.rollbackForm.reason = ""
            this.$nextTick(() => {
                this.rollbackRef &&
                    this.rollbackRef.clearValidate(["target_preparation_status", "reason"])
            })
        }
    }

    async handleOk() {
        try {
            await this.rollbackRef.validate()
            const { target_preparation_status, reason } = this.rollbackForm
            this.$emit("submit", {
                target_preparation_status,
                reason: reason.trim()
            })
            this.$emit("update:visible", false)
        } catch (error) {
            if (error) {
                this.$message.error(`${error}`)
            }
        }
    }
}
